export default{
    //登录接口
    apilogin: '/staff/login',
	
	//企业
	apiCompanyList: '/company/list',//列表
	apiCompanyQueryList: '/company/queryList',//列表-条件
	apiCompanyAdd: '/company/add',//添加
	apiCompanyEdit: '/company/edit',//修改
	apiCompanyDel: '/company/del',//删除
	//员工
	apiStaffList: '/staff/list',//列表
	apiStaffQueryList: '/staff/queryList',//列表-条件
	apiStaffAdd: '/staff/add',//添加
	apiStaffEdit: '/staff/edit',//修改
	apiStaffDel: '/staff/del',//删除
	apiStaffEditPwd: '/staff/editPwd',//删除
	
	//电梯列表
	apiElevatorList: '/elevator/list',//列表
	apiElevatorQueryList: '/elevator/queryList',//列表-条件
	apiElevatorAdd: '/elevator/add',//添加
	apiElevatorEdit: '/elevator/edit',//修改
	apiElevatorDel: '/elevator/del',//删除
	apiElevatorGetNew: '/elevator/getNew',//获取未绑定的电梯编号
	apiElevatorClearNewList: '/elevator/clearNewList',//清空未绑定的电梯编号
	
	//电梯卡管理
	apiCardList: '/card/list',//列表
	apiCardQueryList: '/card/queryList',//列表-条件
	apiCardAdd: '/card/add',//添加
	apiCardEdit: '/card/edit',//修改
	apiCardDel: '/card/del',//删除
	apiCardDyCodeResetBySwipe: '/card/dyCodeResetBySwipe',//动态码重置，根据最后一次刷卡记录回退
	
	//设备操控
	apiElevatorMode: '/elevator/mode',//设置楼层权限
	
	//刷卡记录
	apiSwipeQueryList: '/swipe/queryList',//列表-条件
    
}